export const cmsCheckoutRoot = {
  progressionSteps: [
    {
      routerPath: 'appliance-details',
      label: 'Appliance details',
    },
    {
      routerPath: 'protection-details',
      label: 'Choose protection level',
    },
    {
      routerPath: 'personal-details',
      label: 'Your details',
    },
    {
      routerPath: 'marketing-preferences',
      label: 'Marketing Preferences',
    },
    { routerPath: 'checkout', label: 'Payment' },
    {
      routerPath: 'checkout/order-confirmation',
      label: 'Confirmation',
    },
  ],
};
